import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {AutomatedPaymentsFilter} from '../components/payments-filter/AutomatedPaymentsFilter';
import {AutomatedPaymentsTable} from '../components/payments-table/AutomatedPaymentsTable';
import {PaymentsFooter} from '../components/payments-footer/PaymentsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function AutomatedPaymentsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'automated-payments-list-card'}>
      <AutomatedPaymentsFilter/>
      <AutomatedPaymentsTable/>
      <FooterBar>
        <PaymentsFooter/>
      </FooterBar>
    </Card>
  );
}
